/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");
import { Injectable, Inject } from '@angular/core';

export function initialize(module: ng.IModule) {
    module.service(WorkgroupPersonDataService.Id, WorkgroupPersonDataService);

    WorkgroupPersonDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

@Injectable()
export class WorkgroupPersonDataService extends base.BaseDataService<Nema.Crew.Model.WorkGroupPerson> implements IWorkgroupPersonDataService {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "workgroupPersonDataService";

    public get EntityName(): string {
        return "WorkGroupPerson";
    }

    public get EntitiesName(): string {
        return "WorkGroupPersons";
    }

    /**
     * Override the getAll, since WorkGroupPerson do not 
     * have the Active and SortTag properties.
     */
    public getAll(_active: boolean = true) {

        var self = this;

        var entityQuery = self.createEntityQuery()
            .using(this.entityManager);

        var promise = entityQuery.execute()
        // ignore remote query results and chain to local query. Discarded the query results ... but items remain in cache
            .then(() => {
                self.entityCollection = entityQuery.using(self.breeze.FetchStrategy.FromLocalCache).executeLocally();
                return <Nema.Crew.Model.WorkGroupPerson[]><any>self.entityCollection;
        });

        return promise;
    }

    public getAllPersons(_workGroupId: number = 0) {

        var self = this;

        var entityQuery = self.createEntityQuery()
            .where("WorkGroupId", "==", _workGroupId)
            .using(this.entityManager);

        var promise = entityQuery.execute()
            // ignore remote query results and chain to local query. Discarded the query results ... but items remain in cache
            .then(() => {
                self.entityCollection = entityQuery.using(self.breeze.FetchStrategy.FromLocalCache).executeLocally();
                return <Nema.Crew.Model.WorkGroupPerson[]><any>self.entityCollection;
            });

        return promise;
    }
}

export interface IWorkgroupPersonDataService extends base.IDataService<Nema.Crew.Model.WorkGroupPerson> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/workgrouppersons.dataservice.ts